export const worksInfo = [{
    id: 0,
    title: "guild.LFG",
    langs: "HTML, CSS, JavaScript/JSX, React, Bootstrap 5, Node, Express, Mongoose, MongoDB, Visual Studio Code",
    desc: "I made a social media website for desktop as a project for my last computer science class. I had to teach" +
                " myself a lot through YouTube and other online documentation about backends and how they work with databases." +
                " I used a few different libraries and heroicons.com to help put the website together and make it look ok." +
                " This was a big learning experience for me and I found out so many new things." +
                " Feel free to check it out!",
    img: "images/guilddotlfg proj.png",
    link: "https://www.guilddotlfg.com/"
}, {
    id: 1,
    title: "Knight's Last Stand",
    langs: "C#, Unity, Visual Studio 2022",
    desc: "I made my first game in unity for a game development class I took as a free elective. I made it" +
                " with free art, model, and sound assets from the unity store, but the functionality I wrote myself. It is" +
                " a simple 3D, third-person, wave-based game where you fight for your survival and upgrade your character." +
                " I coded it in C#, so it gave me experience working with something that uses that language. " +
                "Other details can be found by clicking on the link to the game.",
    img: "https://img.itch.zone/aW1hZ2UvMjY2ODAyNS8xNTkxMDE5OC5wbmc=/original/1tVSv4.png",
    link: "https://bentheperson101.itch.io/knights-last-stand"
}, {
    id: 2,
    title: "React Project for School",
    langs: "HTML, CSS, JavaScript/JSX, React, Bootstrap 5, Visual Studio Code",
    desc: "This was the final project for my Innovative Web Development course. It is not anything big, but it " +
                "is a website that uses react and has different functionality. There is a list of favorite planets that " +
                "you can add to and remove from using a JSON object that is stored in a data file. Other pages just display" +
                " information and use components. The logo is custom, and the planet list on the home page also uses a JSON" +
                " object in a data file. The link brings you to a GitHub page with the code and some screenshots provided.",
    img: "images/react proj.png",
    link: "https://github.com/Bentheperson101/React-school-project-code"
}, {
    id: 3,
    title: "PHP/SQL Assignment Example",
    langs: "HTML, JavaScript, PHP, SQL, XAMPP",
    desc: "This is a simple assignment, not a project. It is here to show I have used these languages and " +
                "tools before until I complete a full project with the languages. The assignment includes a login page" +
                " and the functionality for retrieving  data from the database. The link brings you to a GitHub page with " +
                "the code and some screenshots provided.",
    img: "images/php img.png",
    link: "https://github.com/Bentheperson101/PHP-SQL-school-assignment-example"
}];